import React from 'react';
import styles from './bankTilesGrid.module.scss';
import BankTile from './BankTile';
import { MAX_NUMBER_OF_TILES } from '../../constants/bankSelectConstants';
import Spinner from '../spinner/Spinner';
import { IBankDto } from '../../domain/dto/IBankDto';
import { useTranslation } from 'react-i18next';

interface IProps {
  data: IBankDto[];
  onSelect: (brandId: number) => void;
  isLoading: boolean;
}

const BankTilesGrid: React.FC<IProps> = ({ onSelect, data, isLoading }) => {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <div className={`h-full grid place-content-center text-center`}>
        <Spinner /> <span className="mt-2">{t('Loading...')}</span>
      </div>
    );
  }

  return (
    <div className={styles.bankTileContainer} data-testid="bank-tiles-grid">
      {data?.map((item, index) => {
        const to = item.providers.length > 1 ? '/provider-selection' : '/consent';
        return index < MAX_NUMBER_OF_TILES ? (
          <BankTile
            to={to}
            className={`border-1 border-gray-300 hover:border-primary-2 max-[375px]:min-h-[70px] min-h-[98px] sm:min-h-[94px] lg:min-h-[98px]`}
            data={item}
            key={item.brandId}
            onClick={() => onSelect(item.brandId)}
          />
        ) : (
          <div key={index} />
        );
      })}
    </div>
  );
};

export default BankTilesGrid;
